// 劳务管理
const teamUrlJg = '/business/jgTeamManagement/' // 班组
const teamUrl = '/business/yhTeamManagement/' // 班组
const workerAttendanceUrl = '/business/yhSingleAttendance/' // 工人考勤
const teamsAttendanceUrl = '/business/yhTeamAttendance/' // 班组考勤
const extraworkAttendanceUrl = '/business/yhOvertime/' // 加班记录
const taiBanUrl = '/business/yhMachineTeam/' // 台班劳务
const yhAttendanceCountUrl = '/business/yhAttendanceCount/' // 台班劳务

export default {
  insertTeamLabor: '/business/teamLabor/insertTeamLabor',
  updateTeamLabor: '/business/teamLabor/updateTeamLabor',
  updateTeamLaborStatus: '/business/teamLabor/updateTeamLaborStatus',
  deleteTeamLabor: '/business/teamLabor/deleteTeamLabor',
  selectTeamLaborByTeamLaborId: '/business/teamLabor/selectTeamLaborByTeamLaborId',
  selectTeamLaborByPage: '/business/teamLabor/selectTeamLaborByPage',
  selectYhTeamByList: teamUrlJg + 'selectYhTeamByList',
  selectYhTeamByPage: teamUrlJg + 'selectYhTeamByPage',
  selectYhTeamByTeamId: teamUrlJg + 'selectYhTeamByTeamId',
  selectYhTeamByTeamIdJg: teamUrlJg + 'selectYhTeamByTeamId',
  insertYhTeam: teamUrlJg + 'insertYhTeam',
  updateYhTeam: teamUrlJg + 'updateYhTeam',
  updateYhTeamJg: teamUrlJg + 'updateYhTeam',
  deleteDataYhTeam: teamUrlJg + 'deleteDataYhTeam',
  forbiddenYhTeam: teamUrlJg + 'forbiddenYhTeam',
  selectYhSingleAttendanceByPage: workerAttendanceUrl + 'selectYhSingleAttendanceByPage',
  selectYhSingleAttendanceDetail: workerAttendanceUrl + 'selectYhSingleAttendanceDetail',
  selectYhTeamAttendanceByPage: teamsAttendanceUrl + 'selectYhTeamAttendanceByPage',
  selectYhTeamAttendanceDetail: teamsAttendanceUrl + 'selectYhTeamAttendanceDetail',
  updateTeamSignNum: teamsAttendanceUrl + 'updateTeamSignNum',
  selectYhTeamSignModifyLogByPage: teamsAttendanceUrl + 'selectYhTeamSignModifyLogByPage',
  selectYhTeamSignModifyLogByModifyId: teamsAttendanceUrl + 'selectYhTeamSignModifyLogByModifyId',
  selectOvertimeRecordByPage: extraworkAttendanceUrl + 'selectOvertimeRecordByPage',
  verifyYhOvertime: extraworkAttendanceUrl + 'verifyYhOvertime',
  insertYhOvertime: extraworkAttendanceUrl + 'insertYhOvertime',
  updateYhOvertime: extraworkAttendanceUrl + 'updateYhOvertime',
  deleteYhOvertime: extraworkAttendanceUrl + 'deleteYhOvertime',
  selectYhOvertimeRecordDetailByOvertimeId: extraworkAttendanceUrl + 'selectYhOvertimeRecordDetailByOvertimeId',
  selectYhAttendanceCountByWeb: yhAttendanceCountUrl + 'selectYhAttendanceCountByWeb',
  selectYhMachineTeamByPage: taiBanUrl + 'selectYhMachineTeamByPage',
  insertYhMachineTeam: taiBanUrl + 'insertYhMachineTeam',
  updateYhMachineTeam: taiBanUrl + 'updateYhMachineTeam',
  deleteYhMachineTeam: taiBanUrl + 'deleteYhMachineTeam',
  selectYhMachineTeamByMachineTeamId: taiBanUrl + 'selectYhMachineTeamByMachineTeamId',
  selectYhMachineryByList: '/business/yhMachinery/selectYhMachineryByList',
  // 轨迹
  track: '/business/watchWorker/selectTrack',
  // 查询设备下拉列表
  selectYhDeviceByList: '/business/jgWorkerInfo/selectYhDeviceByList',
  // 查询工人或设备轨迹
  selectYhTrajectory: '/business/jgWorkerInfo/selectYhTrajectory'
}
